<template>
  <div class="custTabsMain">
    <div class="custCol">
      <div class="custRow" style="margin: 0 0 8px 0;"> 
        <Radio title="Customer Type" :buttons.sync="radioButtons" :isHorizontal="true" itemKey="title" :checked.sync="radioChecked"/> 
      </div>
      <div class="custRow"> <Dropdown placeholder="Category" :isRequired="true"/> </div>
      <div class="custRow"> 
        <Dropdown placeholder="Status" :isRequired="true"/>
        <DateTime title="From"/>
      </div>
      <div class="custRow"> <Input placeholder="Name" :isRequired="true"/> </div>
      <div class="custRow"> <Input placeholder="Short Name" :isRequired="true"/> </div>
      <div class="custRow"> <Input placeholder="Comp Reg. No"/> </div>
      <div class="custRow"> <Input placeholder="Subsidiary Of"/> </div>
    </div>
    <div class="custCol">
      <div class="custRow"> <Address /> </div>
      <div class="custRow">
        <Input placeholder="Phone No"/>
        <Input placeholder="Fax No"/>
      </div>
      <div class="custRow"> <Input placeholder="Email"/> </div>
      <div class="custRow"> <Dropdown placeholder="Branch"/> </div>
    </div>

    <Loader :isVisible="loadShow" :loadingText="loadText" />
  </div>
</template>

<script>
  /* eslint-disable */
  import Menu from '@/components/Menus.vue';
  import Tabulator from '@/components/Tabulator.vue';
  import EntryPopup from '@/components/EntryPopup.vue';
  import TabView from '@/components/TabView.vue';
  import Input from '@/components/Input.vue';
  import InputQuery from '@/components/InputQuery.vue';
  import DateTime from '@/components/DateTimePicker.vue';
  import Dropdown from '@/components/Dropdown.vue';
  import Loader from '@/components/Loader.vue';
  import Address from '@/components/AddressForm.vue';
  import Radio from '@/components/RadioButton.vue';
  
  export default {
    name: 'customer',
    components: {
      Menu, Tabulator, EntryPopup, Input, InputQuery, DateTime, Dropdown, TabView, Loader, Address, Radio
    },
    data() {
      return {
        //-------- Main Data
        localData: {
          'CustType' : '',
          'CustCategory' : '',
          'Status' : '',
          'StatusValidFr' : '',
          'cu_name' : '',
          'cu_sname' : '',
          'Cus_RegNo' : '',
          'Subsidiary' : '',
          'cu_addr1' : '',
          'cu_addr2' : '',
          'cu_addr3' : '',
          'cu_addr4' : '',
          'Postcode' : '',
          'City' : '',
          'State' : '',
          'Country' : '',
          'cu_phone' : '',
          'cu_fax' : '',
          'cu_email' : '',
          'BrCode' : '',
        },

        //-------- Radio button Data
        radioButtons: [
          { title: 'Both', value: '0' }, 
          { title: 'Customer (Shipper / Consignee)', value: '1' }, 
          { title: 'ArCustomer (Bill To)', value: '1'}],
        radioChecked: [],

      }
    },
    props: {
      //-------- Main Props
      data: { type: Object, default: function () { return {} } },
      viewMode: { type: Boolean, default: false },
    },
    mounted() {
      
    },
    methods: {
      custBtnClick: async function(btn) {
        switch(btn) {
          case 'test':
            break;
        }
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
    },
  };
</script>

<style scoped>

  .custTabsMain {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .custCol {
    width: auto;
    height: 100%;
    max-width: 40%;
    margin: 0 2px;
    flex: 1;
  }

  .custRow {
    width: 100%;
    height: auto;
    min-height: 30px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .custRow * {
    height: 100%;
    margin: 0 4px;
    flex: 1;
  }

</style>
